import axios, { AxiosResponse } from "axios";
//import dotenv from 'dotenv'
// TODO Access the process.env file
// require('dotenv').config();
export interface SuggestionDTO {
  root_pattern: string[];
  compound_noun: string[];
  portnateau: string[];
}
export interface ProcessDTO {
  important_words: ImportantWordsDTO[]
  patterns: string[]
  roots: string[]
}
export interface ImportantWordsDTO {
  english: string,
  hebrew: string[]
}
export interface ResponseDTO {
  suggestions: SuggestionDTO,
  process: ProcessDTO
}

export async function suggest(word: string): Promise<ResponseDTO> {
  word = word.toLocaleLowerCase();
  const url = process.env.VUE_APP_BACKEND;
  const response  = await axios.get<ResponseDTO>(
    `${url}/suggest?word=${word}`
  )
  return response.data;
}
